<template>
  <div>
    <div class="d-flex flex-stack flex-wrap">
        <div class="page-title d-flex flex-column me-3 mt-3">
            <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">
                Language Translations
            </h1>
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1">
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">Home</router-link>
                    </a>
                </li>
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">Settings</router-link>
                </li>
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'SystemSettings' }">System Settings</router-link></li>
                <li class="breadcrumb-item text-gray-600">Update Language Translations</li>
            </ul>
        </div>
        <div class="d-flex align-items-center py-1">
            <router-link to="/SystemSettings">
                <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> Return back to Settings </span>
                </button>
            </router-link>
        </div>
    </div>
    <div class="content flex-row-fluid mt-4" id="kt_content">
        <RequiredField></RequiredField>
        <div class="row">
            <div class="card card-xxl-stretch">
                <div class="card-body">
                    <form id="kt_ecommerce_settings_general_form"
                        class="form fv-plugins-bootstrap5 fv-plugins-framework">
                        <div class="fv-row row">
                            <div class="col-lg-10">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    Select Language
                                </label>
                                <div class="row">
                                    <div class="col-xl-6">
                                        <Select2 :options="languageList" v-model="selectedLanguage"
                                            @select="fetchTranslations" :settings="{ width: '100%' }" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2" v-if="this.translations.length > 0">
                                <button type="button" class="btn btn-success btn-sm float-end my-5"
                                    @click="getExportList">
                                    Export to Excel
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="my-5" v-if="translations.length > 0 || searchQuery">
                        <div class="mb-3">
                            <div class="input-group mb-3">
                                <input type="search" class="form-control"
                                    placeholder="Search: key, original text or custom value" v-model="searchQuery"
                                    @keyup.enter="fetchTranslations" @input="onInput" />
                                <span class="input-group-append">
                                    <button type="button" class="btn btn-primary" @click="fetchTranslations()">
                                        <i class="bi bi-search"></i> Search
                                    </button>
                                </span>
                            </div>
                        </div>

                        <table class="table table-rounded text-gray-800 border px-5">
                            <thead>
                                <tr class="fw-bold">
                                    <th>Key</th>
                                    <th>Original Text</th>
                                    <th>Custom Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in translations" :key="item.key">
                                    <td :title="item.key">{{ item.key.length > 20 ? item.key.slice(0,30) + '...' :
                                        item.key }}</td>
                                    <td>{{ item.original }}</td>
                                    <td class="w-50">
                                        <div class="input-group">
                                            <input type="text" class="form-control" :value="item.custom"
                                                @input="updateCustomValue(item, $event.target.value)" />
                                            <span class="input-group-append">
                                                <button class="btn btn-secondary" @click="saveTranslation(item)">
                                                    <i class="fa fa-save text-success"></i>
                                                </button>
                                                <button class="btn btn-light" @click="deleteTranslation(item)">
                                                    <i class="fa fa-trash text-danger"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <nav class="mt-4" v-if="totalPages > 1">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage - 1)">Previous</a>
                                </li>
                                <li class="page-item" v-for="n in visiblePages" :key="n"
                                    :class="{ active: n === currentPage }">
                                    <a class="page-link" href="#" @click.prevent="changePage(n)">{{ n }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                    <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
  name: "ListingParameters",
  data() {
    return {      
      languageList:[],
      searchQuery: '',
      selectedLanguage: '',
      translations: [],
      totalTranslations: 0,
      currentPage: 1,
      perPage: 50,
      exportList: [],
      isLanguageValuesEmpty: false,
    };
  },
  computed:{
    totalPages() {
      return Math.ceil(this.totalTranslations / this.perPage);
    },
    visiblePages() {
      const maxVisible = 10;
      let start = Math.max(this.currentPage - Math.floor(maxVisible / 2), 1);
      let end = start + maxVisible - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisible + 1, 1);
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    getData(){
      this.activeView = 'TranslateValues';
      this.selectedLanguage = '-1';
      const params = {
        session_id : this.$getUser().session_id,
      };
      axios.post('/api/Lists/GetLanguageList',params,{'Content-Type' : 'application/json'})
      .then((response) => {
        this.languageList = response.data
        this.languageList.unshift({ id: '-1', text: 'Select an option' });
      });
    },
    onChangeTranslateSelection(e){
       const params = {
          session_id: this.$getUser().session_id,
          language_code: e
        };
        axios.post('/api/SystemParameters/GetCompanyLanguageTranslateValues', params, {'Content-Type': 'application/json'})
        .then((response) =>{
          this.selectedLocalLanguageList = response.data;
          if(response.data.length == 0){
            this.isLanguageValuesEmpty = true;
          }
        });
    },
    fetchTranslations() {
      if (!this.selectedLanguage) return;
      if(this.searchQuery) this.currentPage = 1;

      const payload = {
        session_id: this.$getUser().session_id,
        fileName: `${this.selectedLanguage}.json`,
        page: this.currentPage,
        limit: this.perPage,
        searchQuery: this.searchQuery
      };
      axios.post('/api/translations/preview', payload)
        .then((response) => {
          if (response.data?.error) {
            this.translations = [];            
            return;
          }
          this.translations = response.data.data;
          this.totalTranslations = response.data.total;
        })
        .catch((err) => {
          console.error("API hatası:", err);
        });
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchTranslations();
      }
    },
    saveTranslation(item){
      const params = {
        session_id: this.$getUser().session_id,
        language_code: this.selectedLanguage,
        translation_key: item.key,
        custom_value: item.custom,
        is_active: item.is_active ? 1 : 0
      };
      axios.post('/api/SystemParameters/SaveCompanyLanguageTranslateValues', params, {'Content-Type': 'application/json'})
      .then((response) =>{
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
         this.$swal("Success", "Data saved succesfully..!", 'success');
        }
      })
      .catch(function (error) {
          console.error(error);
          this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
      });
    },
    deleteTranslation(item){      
      this.$swal.fire({
        title: 'Are you sure you want to delete this data?',
        confirmButtonColor: "#f1416c",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        icon: 'info'
      })
      .then((result) => {
        if (result.isConfirmed) {  
          const params = {
            session_id: this.$getUser().session_id,
            language_code: this.selectedLanguage,
            translation_key: item.key
          };
          axios.post('/api/SystemParameters/DeleteCustomTranslateValues', params, {'Content-Type': 'application/json'})
          .then((response) =>{
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
              item.custom = null;
            this.$swal("Success", "Data deleted succesfully..!", 'success');
            }
          })
          .catch(function (error) {
              console.error(error);
              this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
          });
        }
      }); 
    },
    exportToExcel() {
      const exportData = this.exportList.map(item => ({
        Key: item.key,
        Orijinal: item.original,
        'Custom Değer': item.custom
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Translations');

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(blob, this.selectedLanguage + '-Translations.xlsx');
    },  
    getExportList(){
      const params = {
        session_id : this.$getUser().session_id,
        fileName :  `${this.selectedLanguage}.json`,
      };
      axios.post('/api/translations/ExportList',params).then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.exportList = response.data;
          this.exportToExcel();
        }
      }).catch((error => {
        console.error(error);
        this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
      }));
    },
    updateCustomValue(item, value) {
      item.custom = value;
    },
    onInput() {
      if (this.searchQuery === '') {
        this.fetchTranslations();
      }
    }
  },
  mounted() { 
    this.getData();
  }
}; 
</script>